// extracted by mini-css-extract-plugin
module.exports = {"formTitle":"style_formTitle__1TSLM","backIcon":"style_backIcon__23FjT","closeIcon":"style_closeIcon__7g9Kh","formName":"style_formName__2qpx4"};